import axios from "axios";

// ⚠️ Adapte cette URL à l'emplacement de ton dossier backend PHP
const api = axios.create({
  baseURL: "https://alcoolometre.synchrodev.fr/backend",
});

// Ajoute automatiquement le token sur chaque requête
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Si le token est expiré/invalide, on déconnecte proprement
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);

export default api;
